import { MAX_TEXT_INPUT_VALIDATION } from "@/constants/common";
import { PATTERN } from "@/constants/pattern";
import { validator } from "@/utils/validator";

export const wordEditSchema = validator.object().shape({
  vocabularyBookMemo: validator.string().trim().emptyToNull().max(MAX_TEXT_INPUT_VALIDATION).label("社内メモ").notRequired(),
  vocabularyBookSpreadsheetUrl: validator
    .string()
    .trim()
    .emptyToNull()
    .max(MAX_TEXT_INPUT_VALIDATION)
    .matches(PATTERN.CUSTOM_URL, "正しいURL形式で入力してください。")
    .label("単語データのスプレッドシートURL")
    .required(),
});
